const STORAGE_KEY = 'lauduz_push_token'
const OPT_OUT_KEY = 'lauduz_push_opt_out'

/**
 * Guarda o FID registrado neste dispositivo, pra ter o que revogar no logout e pra saber qual
 * identificador revogar quando ele muda. A chave é a mesma da época do token FCM legado, de
 * propósito: é assim que o usePushNotifications encontra o token antigo e o revoga na migração.
 */
export const getStoredPushToken = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

export const setStoredPushToken = (token: string | null): void => {
  try {
    if (token) localStorage.setItem(STORAGE_KEY, token)
    else localStorage.removeItem(STORAGE_KEY)
  } catch {
    // localStorage indisponível (ex: modo privado) — segue sem cache, só perde a otimização
  }
}

/**
 * O usuário desligou notificações push neste navegador de propósito. Sem um endpoint no
 * backend pra consultar se o token está ativo, esse flag local é quem impede o
 * `usePushNotifications` de registrar de novo sozinho na próxima sessão.
 */
export const getPushOptOut = (): boolean => {
  try {
    return localStorage.getItem(OPT_OUT_KEY) === 'true'
  } catch {
    return false
  }
}

export const setPushOptOut = (optOut: boolean): void => {
  try {
    if (optOut) localStorage.setItem(OPT_OUT_KEY, 'true')
    else localStorage.removeItem(OPT_OUT_KEY)
  } catch {
    // localStorage indisponível — segue sem lembrar a preferência entre sessões
  }
}
